import React, { useCallback } from 'react'
import { withEmptyFallbackErrorBoundary } from '../error/EmptyFallbackErrorBoundary'
import SVGIcon from '../svg/SVGIcon'
import s from './PanoPreview.less'
import TagActionButton from '../genericComponents/TagActionButton'
import { useAction } from '../utils/react-redux'
import { navigateTo } from '../../store/history/history.actions'
import { ROUTE_360_VIEW_FULLSCREEN } from '../../routes'
import SeoBackgroundImage from '../genericComponents/SeoBackgroundImage'

function PanoPreview({ panoData, tagId, sendBiTag, alt }) {
  const execNavigateTo = useAction(navigateTo)

  const onClick = useCallback(() => {
    if (sendBiTag) sendBiTag()
    execNavigateTo({
      route: ROUTE_360_VIEW_FULLSCREEN,
      routeOptions: panoData
    })
  }, [execNavigateTo, panoData])

  if (!panoData.url) return null

  return (
    <TagActionButton type={tagId} className={s.PanoPreview} onClick={onClick} deferClick>
      <SeoBackgroundImage alt={alt} imgUrl={panoData.url} className={s.PreviewImage} />
      <SVGIcon className={s._360Icon} icon="vue-360" />
    </TagActionButton>
  )
}

export default withEmptyFallbackErrorBoundary(PanoPreview)
